import React from 'react';

/**
 *
 * SVG sound muted Icon
 *
 */
function Muted() {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1.4142"
      version="1.1"
      viewBox="0 0 200 292"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
    >
      <path
        d="m178.43 56.307c-4.802 0-10.164 1.456-15.82 4.536l-19.908 10.864 15.666-58.485c1.505-5.6-1.827-11.361-7.427-12.859-5.607-1.512-11.361 1.834-12.859 7.427l-20.853 77.812-26.817 14.63h-55.412c-19.25 0-35 15.75-35 35v21c0 19.25 15.75 35 35 35h53.942l-23.317 87.017c-1.505 5.6 1.827 11.354 7.427 12.852 3.759 1.015 7.588-0.154 10.143-2.723 1.267-1.26 2.219-2.856 2.716-4.704l22.183-82.796 54.523 29.743c5.656 3.08 11.018 4.536 15.82 4.536 12.418 0 21.056-9.772 21.056-26.425v-126c-7e-3 -16.66-8.638-26.425-21.063-26.425zm-85.337 113.92h-16.681-41.412c-7.7 0-14-6.3-14-14v-21c0-7.7 6.3-14 14-14h58.093c1.47 0 3.731-0.574 5.026-1.288 1.099-0.595 6.02-3.283 11.62-6.335l-15.225 56.826c-0.49-0.07-1.022-0.203-1.421-0.203zm85.393 31.122c0 7.7-5.53 10.983-12.292 7.294l-52.514-28.644 21.511-80.283 31.003-16.912c6.762-3.689 12.292-0.406 12.292 7.294v111.25z"
        fillRule="nonzero"
      />
    </svg>
  );
}

export default Muted;



// WEBPACK FOOTER //
// ./src/layout/graphics/MutedIcon.js